import "features/shared/styles/flags/Flags.css";

import { countryCodesByAlpha3 } from "assets/country-codes/country-codes";
import { nationalitiesByAlpha3 } from "assets/country-codes/nationalities";
import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import { MicroHeaderXS } from "features/shared/styles/typography/MicroHeaderXS.styled";
import { SmallPrint } from "features/shared/styles/typography/SmallPrint.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { FC } from "react";
import { useAppStore } from "store/store";
import { formatIsoDateToLocale } from "utils";

import FlagContainerPassportPreview from "./styles/FlagContainerPassportPreview";
import PassportContainer from "./styles/PassportContainer.styled";
import PreviewField from "./styles/PreviewField.styled";
import StyledPassportPreview from "./styles/StyledPassportPreview.styled";

const PassportPreview: FC = () => {
  const images = LocalImages.shared.images;
  const passport = useAppStore((state) => state.passportValues);
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.passport });
  const nationality =
    (nationalitiesByAlpha3[passport.nationality] &&
      nationalitiesByAlpha3[passport.nationality].name) ||
    "";

  return (
    <StyledPassportPreview>
      <PassportContainer dir="ltr">
        <object
          type="image/svg+xml"
          data={images.passportPreview}
          aria-label={text("preview-alt")}
        ></object>
        <Summary>{text("form.title")}</Summary>
        <PreviewField className="first-name">
          <SmallPrint>{text("form.name")}</SmallPrint>
          <MicroHeaderXS>{passport.givenName}</MicroHeaderXS>
        </PreviewField>
        <PreviewField className="last-name">
          <SmallPrint>{text("form.surname")}</SmallPrint>
          <MicroHeaderXS>{passport.surname}</MicroHeaderXS>
        </PreviewField>
        <PreviewField className="passport-number">
          <SmallPrint>{text("form.number")}</SmallPrint>
          <MicroHeaderXS>{passport.number}</MicroHeaderXS>
        </PreviewField>
        <PreviewField className="gender">
          <SmallPrint>{text("form.sex")}</SmallPrint>
          <MicroHeaderXS>{passport.gender}</MicroHeaderXS>
        </PreviewField>
        <PreviewField className="birth-date">
          <SmallPrint>{text("form.birthdate")}</SmallPrint>
          <MicroHeaderXS>
            {formatIsoDateToLocale(passport.birthdate)}
          </MicroHeaderXS>
        </PreviewField>
        <PreviewField className="nationality">
          <SmallPrint>{text("form.nationality")}</SmallPrint>
          <MicroHeaderXS>{nationality}</MicroHeaderXS>
        </PreviewField>
        <PreviewField className="expiry-date">
          <SmallPrint>{text("form.expiry_date")}</SmallPrint>
          <MicroHeaderXS>
            {formatIsoDateToLocale(passport.expiryDate)}
          </MicroHeaderXS>
        </PreviewField>

        {passport.countryCode && (
          <FlagContainerPassportPreview>
            <div
              className={`fflag fflag-${
                countryCodesByAlpha3[passport.countryCode].alpha2
              }`}
            />
          </FlagContainerPassportPreview>
        )}
      </PassportContainer>
    </StyledPassportPreview>
  );
};
export default PassportPreview;
